<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-8">
<h2 class="chap_head"><span class="bold">ACKNOWLEDGEMENTS</span></h2>
<p class="noindent1"><span class="dropcap">H</span>ere I would like to say thank you to James Billingham, who so expertly guided us around Scotland on our many visits all those years ago, for his help and his company and, more recently, for his assistance with the captions, where my notes have let me down. James has also provided extra detail for a number of photographs.</p>
<p class="indent">Thanks are also due to Val Brown and Paul Dorney, who have made suggestions regarding the captions, as well as assisting with checking my text for errors.</p>
<div class="img_container">
<img alt="image" src="images/8.jpg"/>
<p class="caption"><span class="bold">2. The nameplate</span> and the West Highland Terrier emblem of Glasgow Eastfield Traction Maintenance Depot, as carried by English Electric type 3 locomotive 37081. 12 May 1984.</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Acknowledgements.vue?5343ee8c